export default __webpack_public_path__ + "static/rental-fd0df68efea4e63b8a580d65c641905a.jpg";